<template>
  <v-container>
    <h2>TÍTULOS HONORÍFICOS</h2>
    <CRUDIndex
      :permissionRoot="'Honorificos'"
      :headers="headers"
      :storeModel="storeModel"
    />
  </v-container>
</template>

<script>
import CRUDIndex from '../globals/CRUDIndex'
export default {
  components: {
    CRUDIndex
  },
  data () {
    return {
      headers: [
        { text: 'Nombre', value: 'description' },
        { text: 'Abbreviatura', value: 'name' },
      ],
      storeModel: 'HonorificTitle',
    }
  }
}
</script>

<style>

</style>e
